import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { FileServiceProviderConfig } from './FileServiceProviderConfig.entity';

export class DirectoryProbeSuccessResult<T extends EMode = EMode.entity> {
  /** Alias: fileServiceProvider */
  fileServiceProvider?: FileServiceProviderConfig<T>;

  __typename?: string;
}

const fields: FieldDefinitions<DirectoryProbeSuccessResult> = {
  fileServiceProvider: {
    alias: 'fileServiceProvider',
    entity: Entities.fileServiceProviderConfig,
  },
  __typename: {
    alias: '__typename',
  },
};

export const directoryProbeSuccessResultEntityDefinition: EntitiyDefinition<DirectoryProbeSuccessResult> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'DirectoryProbeSuccessResult',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
